import { RootState } from 'store/store';

export const selectContractTypeOptions = (state: RootState) => state.contractType.contractTypeOptions;
export const selectContractTypeStatus = (state: RootState) => state.contractType.contractTypeStatus;
